import mixpanel from 'mixpanel-browser';
import {
  BTN_CLEAR_ALL_NOTIFICATIONS,
  OPTEDIN,
  SUCCESS_TRANSACTION,
} from '../constants/mixpanel';

export const sendSuccessTransactionMPEvent = (
  transactionId: any,
  from: any,
  to: any,
  amount: any,
  type: any,
  nftId?: any,
) => {
  mixpanel.track(SUCCESS_TRANSACTION, {
    transactionId,
    from,
    to,
    amount,
    type,
    nftId,
  });
};
export const sendOptedInMPEvent = (
  wallet: any,
  assetId: any,
  transactionId: any,
) => {
  mixpanel.track(OPTEDIN, {
    wallet,
    assetId,
    transactionId,
    type: 'OptedIn',
  });
};
export const sendClearAllNotificationsMPEvent = (wallet: any) => {
  mixpanel.track(BTN_CLEAR_ALL_NOTIFICATIONS, {
    wallet,
  });
};
